<template>
  <v-skeleton-loader v-if="loading"
                     type="article"
                     height="300"/>
  <content-card v-else
                :title="$t('rooms-card.title').toString()"
                icon="meeting_room">
    <template v-slot:content>
      <v-list subheader class="py-0 tileBackground" v-if="Object.values(rooms)?.length > 0">
        <v-list-item v-for="room in rooms"
                     :key="room.id"
                     class="list-item straight px-5"
                     @click="openRoom(room)">
          <v-list-item-content>
            <v-list-item-title class="font-size-03 primary--text font-weight-bold"
                               v-text="room.name"/>
            <v-list-item-subtitle class="font-size-02">
              {{ room.devices?.length }} {{ $t('rooms-card.devices') }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="primary">chevron_right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-list v-else subheader class="py-0 tileBackground">
        <v-list-item class="grey--text">
          <div class="mx-8 my-4 text-center max-width"
               v-text="$t('rooms-card.empty-state')"/>
        </v-list-item>
      </v-list>
    </template>
  </content-card>
</template>

<script>
import ContentCard from "@/templates/components/ContentCard"
import config from "@/config/config.app.json";
import requestHelper from "@/scripts/requestHelper";

export default {
  name: "RoomsCard",

  components: {ContentCard},

  data() {
    return {
      timer: null,
      refreshRate: config.dataRefreshRate,
      loading: false,
      loadingSwitch: {},
      rooms: []
    }
  },

  methods: {
    /**
     * gets schedules from the API
     */
    getData(showLoader) {
      if (showLoader) {
        this.loading = true
      }

      this.$rhRequest.sendGet({
        endpoint: 'group/get',
      }, (response) => {
        this.rooms = response?.data?.data
        this.loading = false
      }, (error) => {
        console.error(error)
        this.loading = false
      })
    },

    /**
     * continuously updates the data
     */
    updateData() {
      this.timer = setInterval(() => {
        this.getData(false)
      }, this.refreshRate)
    },

    loadCachedData() {
      this.$caching.getData('rooms').then((rooms) => {
        if (rooms !== -1) {
          if (!rooms) {
            this.rooms = []
            this.loading = false
          } else {
            this.rooms = rooms
            this.loading = false
          }
        }
      })
    },

    openRoom(room) {
      this.$root.bisadialog.toggle('addRoom', true, room)
      this.$root.bisadialog.callDialogInit('addRoom')
    }
  },

  mounted() {
    this.loading = true
    this.loadCachedData()
    requestHelper.startDelayedRequest(
        () => this.getData(false),
        () => this.updateData()
    )
    // update room list after adding/removing rooms
    this.$root.$on('updateRoomList', () => {
      this.getData(false)
    })
  },

  beforeDestroy() {
    clearInterval(this.timer)
    this.$root.$off('updateRoomList')
  },

  watch: {
    rooms(newVal) {
      this.$caching.saveData('rooms', newVal)
    }
  }
}
</script>
